export const documentsConstants = {
    CREATE_SQ_DOCUMENT: 'CREATE_SQ_DOCUMENT',
    DELETE_SQ_DOCUMENT: 'DELETE_SQ_DOCUMENT',
    EDIT_SQ_DOCUMENT: 'EDIT_SQ_DOCUMENT',
    SAVE_CUSTOMER_DETAILS: 'SAVE_CUSTOMER_DETAILS',
    CLEAR_ALL_SQ_DOCUMENTS: 'CLEAR_ALL_SQ_DOCUMENTS',
    GET_BY_SQ_DOC_NUM: 'GET_BY_SQ_DOC_NUM'
}